module.exports = __webpack_public_path__ + "static/media/sort-amount-up.fb7edf77.svg";